(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veris-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('veris-comparison')) {
  customElements.define('veris-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.scroller = this.querySelector('.vc2-scroll');
      this.table = this.querySelector('.vc2-table');
      this.hint = this.querySelector('.vc2-scroll-hint');
      if (!this.scroller || !this.table || !this.hint) return;
      this.controller = new AbortController();
      this.frame = 0;
      const refresh = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (!this.isConnected || !this.controller) return;
          const overflowing = this.scroller.scrollWidth > this.scroller.clientWidth + 1;
          this.hint.hidden = !overflowing;
          this.scroller.tabIndex = overflowing ? 0 : -1;
          if (overflowing) {
            this.scroller.setAttribute('role', 'region');
            this.scroller.setAttribute('aria-describedby', this.hint.id);
          } else {
            this.scroller.removeAttribute('role');
            this.scroller.removeAttribute('aria-describedby');
          }
        });
      };
      window.addEventListener('resize', refresh, { passive: true, signal: this.controller.signal });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(refresh);
        this.observer.observe(this.scroller);
        this.observer.observe(this.table);
      }
      document.fonts?.ready.then(() => {
        if (this.isConnected && this.controller) refresh();
      });
      refresh();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veris-features"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('veris-hotspots')) {
  customElements.define('veris-hotspots', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.stage = this.querySelector('.vh5-stage');
      this.frame = this.querySelector('.vh5-frame');
      this.items = Array.from(this.querySelectorAll('.vh5-panel'));
      this.dots = Array.from(this.querySelectorAll('.vh5-dot'));
      this.mobile = matchMedia('(width < 750px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.current = null;
      this.frameRequest = 0;
      this.querySelectorAll('.vh5-toggle').forEach(button => { button.disabled = false; });
      this.addEventListener('click', event => this.onClick(event), { signal });
      this.addEventListener('keydown', event => this.onKey(event), { signal });
      this.addEventListener('focusin', event => {
        if (event.target.closest('.vh5-copy') && !this.mobile.matches) {
          const item = event.target.closest('.vh5-panel');
          item.dataset.expanded = 'true';
          this.updateMore(item);
          this.schedulePosition();
        }
      }, { signal });
      this.mobile.addEventListener('change', () => this.switchLayout(), { signal });
      window.addEventListener('resize', () => this.schedulePosition(), { signal, passive: true });
      if (this.dataset.outsideClose === 'true') {
        document.addEventListener('click', event => {
          if (!this.mobile.matches && this.current && !this.contains(event.target)) this.activate(null);
        }, { signal });
      }
      document.addEventListener('shopify:block:select', event => {
        if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
        const item = this.items.find(panel => panel.dataset.blockId === String(event.detail?.blockId));
        if (item) this.activate(item.dataset.blockId);
      }, { signal });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.schedulePosition());
        this.resizeObserver.observe(this.frame);
        this.items.forEach(item => this.resizeObserver.observe(item));
      }
      this.classList.add('vh5-ready');
      const initial = Math.max(0, Number(this.dataset.initial) || 0);
      this.activate(initial ? (this.items[initial - 1] || this.items[0])?.dataset.blockId : null);
      this.switchLayout();
      if (this.dataset.pulse === 'true' && !this.reduced.matches && 'IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.classList.add('vh5-attention');
            this.intersectionObserver.disconnect();
          }
        }, { threshold: 0.2 });
        this.intersectionObserver.observe(this.frame);
      }
      document.fonts?.ready.then(() => {
        if (this.isConnected && this.controller) this.schedulePosition();
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      cancelAnimationFrame(this.frameRequest);
      this.frameRequest = 0;
    }

    onClick(event) {
      const dot = event.target.closest('.vh5-dot');
      const toggle = event.target.closest('.vh5-toggle');
      const close = event.target.closest('.vh5-close');
      const more = event.target.closest('.vh5-more');
      if (dot) {
        const id = dot.dataset.blockId;
        this.activate(this.current === id && !this.mobile.matches ? null : id);
        if (this.mobile.matches && this.current) {
          const item = this.items.find(panel => panel.dataset.blockId === id);
          item?.querySelector('.vh5-toggle').focus({ preventScroll: true });
          if (this.dataset.scroll === 'true' && item) {
            const rect = item.getBoundingClientRect();
            if (rect.top < 0 || rect.bottom > window.innerHeight) {
              item.scrollIntoView({ behavior: this.reduced.matches ? 'auto' : 'smooth', block: 'nearest' });
            }
          }
        }
      } else if (toggle) {
        const id = toggle.closest('.vh5-panel').dataset.blockId;
        this.activate(this.current === id ? null : id);
      } else if (close) {
        this.activate(null, true);
      } else if (more) {
        const item = more.closest('.vh5-panel');
        item.dataset.expanded = String(item.dataset.expanded !== 'true');
        this.updateMore(item);
        this.schedulePosition();
      }
    }

    onKey(event) {
      if (event.key === 'Escape' && this.current) {
        event.preventDefault();
        event.stopPropagation();
        this.activate(null, true);
        return;
      }
      const button = event.target.closest('.vh5-dot, .vh5-toggle');
      if (!button || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
      const buttons = button.matches('.vh5-dot') ? this.dots : this.items.map(item => item.querySelector('.vh5-toggle'));
      const index = buttons.indexOf(button);
      const rtl = this.getAttribute('dir') === 'rtl';
      const backward = event.key === 'ArrowUp' || event.key === (rtl ? 'ArrowRight' : 'ArrowLeft');
      let next = (index + (backward ? -1 : 1) + buttons.length) % buttons.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = buttons.length - 1;
      event.preventDefault();
      buttons[next]?.focus();
    }

    activate(id, restoreFocus = false) {
      const old = this.current;
      const previousItem = this.items.find(item => item.dataset.blockId === old);
      const focusWillHide = previousItem?.contains(document.activeElement) && old !== id;
      this.current = this.items.some(item => item.dataset.blockId === id) ? id : null;
      this.dots.forEach(dot => dot.setAttribute('aria-expanded', String(dot.dataset.blockId === this.current)));
      this.items.forEach(item => {
        const active = item.dataset.blockId === this.current;
        item.dataset.active = String(active);
        item.hidden = !this.mobile.matches && !active;
        item.querySelector('.vh5-body').hidden = !active;
        item.querySelector('.vh5-toggle').setAttribute('aria-expanded', String(active));
        this.updateMore(item);
      });
      if (restoreFocus || focusWillHide) {
        const focusId = this.current || old;
        const control = this.mobile.matches
          ? this.items.find(item => item.dataset.blockId === focusId)?.querySelector('.vh5-toggle')
          : this.dots.find(dot => dot.dataset.blockId === focusId);
        control?.focus({ preventScroll: true });
      }
      this.schedulePosition();
    }

    switchLayout() {
      const focused = document.activeElement;
      const focusedDot = focused?.closest('.vh5-dot');
      const focusedPanel = focused?.closest('.vh5-panel');
      this.items.forEach(item => {
        item.style.removeProperty('left');
        item.style.removeProperty('top');
        item.style.removeProperty('--vh5-pop-max-height');
        this.updateMore(item);
      });
      this.activate(this.current);
      if (this.mobile.matches && focusedDot && this.contains(focusedDot)) {
        this.items.find(item => item.dataset.blockId === focusedDot.dataset.blockId)?.querySelector('.vh5-toggle').focus({ preventScroll: true });
      } else if (!this.mobile.matches && focusedPanel && this.contains(focusedPanel)) {
        this.dots.find(dot => dot.dataset.blockId === focusedPanel.dataset.blockId)?.focus({ preventScroll: true });
      }
    }

    updateMore(item) {
      const button = item.querySelector('.vh5-more');
      if (!button) return;
      const copy = item.querySelector('.vh5-copy');
      const expanded = item.dataset.expanded === 'true';
      const enabled = !this.mobile.matches && Number(this.dataset.lines) > 0;
      copy.classList.toggle('vh5-clamped', enabled && !expanded);
      const overflows = copy.scrollHeight > copy.clientHeight + 1;
      button.hidden = !enabled || (!expanded && !overflows);
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
    }

    schedulePosition() {
      if (!this.controller || this.frameRequest) return;
      this.frameRequest = requestAnimationFrame(() => {
        this.frameRequest = 0;
        if (!this.isConnected || !this.controller) return;
        this.items.forEach(item => this.updateMore(item));
        this.positionPanel();
      });
    }

    positionPanel() {
      if (this.mobile.matches || !this.current) return;
      const panel = this.items.find(item => item.dataset.blockId === this.current);
      const dot = this.dots.find(item => item.dataset.blockId === this.current);
      if (!panel || !dot) return;
      const frame = this.frame.getBoundingClientRect();
      const dotRect = dot.getBoundingClientRect();
      const inset = 12;
      const gap = 14;
      panel.style.setProperty('--vh5-pop-max-height', `${Math.max(44, frame.height - inset * 2)}px`);
      const width = panel.offsetWidth;
      const height = Math.min(panel.offsetHeight, Math.max(44, frame.height - inset * 2));
      const x = dotRect.left + dotRect.width / 2 - frame.left;
      const y = dotRect.top + dotRect.height / 2 - frame.top;
      const radius = dotRect.width / 2 + gap;
      const candidates = {
        left: [x - radius - width, y - height / 2],
        right: [x + radius, y - height / 2],
        top: [x - width / 2, y - radius - height],
        bottom: [x - width / 2, y + radius]
      };
      const fits = ([left, top]) => left >= inset && top >= inset && left + width <= frame.width - inset && top + height <= frame.height - inset;
      const keepsDotsClear = ([left, top]) => this.dots.every(button => {
        const rect = button.getBoundingClientRect();
        return left + width + 4 <= rect.left - frame.left || left - 4 >= rect.right - frame.left || top + height + 4 <= rect.top - frame.top || top - 4 >= rect.bottom - frame.top;
      });
      const preferred = panel.dataset.placement;
      const order = x > frame.width / 2 ? ['left', 'right', 'bottom', 'top'] : ['right', 'left', 'bottom', 'top'];
      if (candidates[preferred]) order.unshift(preferred);
      const positions = order.map(side => candidates[side]).map(([left, top]) => [
        Math.max(inset, Math.min(left, frame.width - width - inset)),
        Math.max(inset, Math.min(top, frame.height - height - inset))
      ]);
      const position = positions.find(candidate => fits(candidate) && keepsDotsClear(candidate));
      panel.classList.toggle('vh5-stacked', !position);
      if (!position) {
        panel.style.removeProperty('left');
        panel.style.removeProperty('top');
        return;
      }
      panel.style.left = `${position[0]}px`;
      panel.style.top = `${position[1]}px`;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
